import { ClipId } from '../types';

export type SnapTarget = {
  px: number;
  /** If set, snap is ignored when the dragging clip matches this id. */
  clipId?: ClipId;
  /** Tag for diagnostics / future filtering ('clip-start', 'clip-end', 'playhead', etc). */
  kind?: string;
};

export const DEFAULT_SNAP_THRESHOLD_PX = 6;

export type SnapResult = {
  snapped: boolean;
  snappedPx: number;
  targetPx: number | null;
};

/**
 * Returns the nearest snap target within `threshold` of `edgePx`, ignoring
 * targets whose `clipId` matches `excludeClipId`.
 */
export const snapEdge = (
  edgePx: number,
  targets: SnapTarget[],
  excludeClipId: ClipId | null,
  threshold = DEFAULT_SNAP_THRESHOLD_PX
): SnapResult => {
  let best: SnapTarget | null = null;
  let bestDist = threshold + 1;

  for (const t of targets) {
    if (excludeClipId && t.clipId === excludeClipId) continue;
    const d = Math.abs(t.px - edgePx);
    if (d <= threshold && d < bestDist) {
      best = t;
      bestDist = d;
    }
  }

  if (!best) return { snapped: false, snappedPx: edgePx, targetPx: null };
  return { snapped: true, snappedPx: best.px, targetPx: best.px };
};

export const msToPx = (ms: number, pxPerSecond: number, startOffset: number): number =>
  (ms / 1000) * pxPerSecond + startOffset;

export const pxToMs = (px: number, pxPerSecond: number, startOffset: number): number =>
  pxPerSecond > 0 ? ((px - startOffset) / pxPerSecond) * 1000 : 0;
